import React, { Component } from "react";

import LandingPage from "./LandingPage/LandingPage";
import InitialForm from "./InitialForm/InitialForm";
import "../assets/styles/style.css";
import apiService from "./Services/APIService";
import HWUser from "./HWLibrary/HWUser";
import "react-block-ui/style.css";
import closeImg from "../images/close-icon.png";
import xmppService from "./Services/XMPPService";
import HWLog from "./HWLibrary/HWLog";
import ConversationPage from "./Conversation/ConversationPage";
import StartUp from "./StartUp";
import { s360ConfigService } from "./Services/S360Config";
import ActivityIndicator from "./CommonUtils/ActivityIndicator";
import PopUpMessage from "./CommonUtils/PopUpMessage";
import {
  sendOnAppOpen,
  sendOnAppClose,
  watchForChatSDKEvents,
} from "./Services/HWIframeBridge";
import IframeContainer from "../utils/IframeContainer/IframeContainer";
import { CometdActions } from "../cometD/cometD-action";
import { MyContext } from "../context/Mycontext";
import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import { getUILogs } from "./HWLibrary/HWUtils";

class Simplify360Chat extends Component {
  constructor(props) {
    super(props);

    this.dialogRef = React.createRef();
    this.lastFocusedRef = React.createRef();
    this.headingRef = React.createRef();

    const isLoggedIn = HWUser.isLoggedIn();
    HWLog.info("Is Logged In: " + isLoggedIn);
    this.timer = 0;
    const showForm = s360ConfigService?.config?.configDetails?.showForm;
    let firstPage =
      !isLoggedIn && showForm
        ? Simplify360Chat.pageName.initialForm
        : Simplify360Chat.pageName.landingPage;
    firstPage = s360ConfigService?.config?.configDetails?.offline
      ? "offlinePage"
      : firstPage;
    let showActivityIndicator = isLoggedIn ? false : !(!isLoggedIn && showForm);
    this.state = {
      visiblePage: firstPage,
      isAppOpen: false,
      showForm: showForm,
      showPopUpMessage: false,
      showActivityIndicator: showActivityIndicator,
      goback: false,
      isVisible: false,
      timer: 0,
      text: "",
      isActive: false,
      refreshForFullScreen: false,
      showFeedbackIframe: false,
      iframeSRC: "",
      isIframeClose: false,
      uniboxSingleRefresh: false,
      showLogs: false,
      logs: []
    };
  }
  // assigning context to current page context
  static contextType = MyContext
  static pageName = {
    // enum
    initialForm: "initialForm",
    landingPage: "landingPage",
    conversationPage: "conversationPage",
    offlinePage: "offlinePage",
  };

  componentDidMount() {
    if (s360ConfigService.config.autoFullScreen) {
      localStorage.setItem("openInFullScreen", true);
      window.parent.postMessage(
        {
          fullScreen: "true",
        },
        "*" //or "www.parentpage.com"
      );
    } else {
      localStorage.removeItem("openInFullScreen");
    }
    // console.log(s360ConfigService.config.autoPopup, "CONFIG CHECK");
    if (
      s360ConfigService.config.autoPopup ||
      sessionStorage.getItem("autoOpenChat") ||
      s360ConfigService.config.hideIcon
    ) {
      this.onStartUpClick();
      sessionStorage.removeItem("autoOpenChat");
    }
    if (this.state.isAppOpen && !HWUser?.isLoggedIn()) {
      this.checkAndAutoLogin();
    }

    if (!HWUser?.isLoggedIn()) {
      this.startTimer();
    }
    if (localStorage.getItem("autoOpenChat")) {
      this.onStartUpClick();
    }
    if (s360ConfigService.config.disableLocalSession) {
      window.parent.postMessage(
        {
          deleteClientHostId: "true",
        },
        "*" //or "www.parentpage.com"
      );
    }
  }

  handleKeydown = (e) => {
    if (e.key !== "Tab") return;

    const focusables = this.dialogRef.current?.querySelectorAll(
      'a[href], button, input, textarea, select'
    );
    const list = Array.from(focusables).filter(el => !el.disabled && el.offsetParent !== null);
    const first = list[0], last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.chatMaximized !== this.props.chatMaximized) {
      this.onStartUpClick();
    }

    if (prevState.isAppOpen !== this.state.isAppOpen) {
      // open/close focus management
      if (this.state.isAppOpen) {
        this.lastFocusedRef.current = document.activeElement;
        const toFocus = this.headingRef
        setTimeout(() => toFocus.current?.focus(), 0);

        this.dialogRef.current?.addEventListener("keydown", this.handleKeydown)
      } else {
        this.lastFocusedRef.current?.focus();
      }
    }
  }
 
  componentWillUnmount() {
    this.dialogRef.current?.removeEventListener("keydown", this.handleKeydown)
  }

  handleClose = () => {
    this.setState({ isVisible: false });

    //  if(window.innerWidth < 500 && s360ConfigService.timerMessages.length>0)
    //  { window.parent.postMessage(
    //     {
    //       iframeMinimized:'true'
    //     },
    //     "*"
    //   )}
  };

  isActiveConversation = () => {
    let isClosed =
      (this.state.activeConversation &&
        this.state.activeConversation.active != null &&
        this.state.activeConversation.active !== undefined &&
        this.state.activeConversation.active === false) ||
      !this.state.activeChatSession;

    return !isClosed;
  };

  startTimer = () => {
    if (s360ConfigService?.config?.popupMessage?.length > 0) {
      s360ConfigService?.config?.popupMessage?.sort(
        (a, b) => this.getTimeInSec(a.time) - this.getTimeInSec(b.time)
      );
      // console.log("arr", s360ConfigService.config.popupMessage);
      this.timer = setInterval(this.countIncrease, 1000);
      if (
        s360ConfigService.config.disableTimerMessages !== null &&
        s360ConfigService.config.disableTimerMessages !== undefined &&
        !s360ConfigService.config.disableTimerMessages
      ) {
        // console.log("int..", s360ConfigService.config.popupMessage.at(-1).time);
        let lap = s360ConfigService?.config?.popupMessage?.at(-1)?.time;
        if (lap !== undefined) {
          if (this.getTimeInSec(lap) < this.state.timer) {
            clearInterval(this.timer);
          }
        }
      }
    }
  };

  getTimeInSec = (time) => {
    if (time !== undefined) {
      const [hours, minutes, seconds] = time.toString().split(":");
      let totalSeconds = +hours * 60 * 60 + +minutes * 60 + +seconds;
      return totalSeconds;
    }
  };
  countIncrease = () => {
    let interval = this.state.timer + 1;
    this.setState({ timer: interval });
    //  console.log("time",interval);
    if (
      s360ConfigService.config.disableTimerMessages !== null &&
      s360ConfigService.config.disableTimerMessages !== undefined &&
      !s360ConfigService.config.disableTimerMessages
    ) {
      let lap = s360ConfigService.config?.popupMessage.at(-1).time;
      if (lap !== undefined) {
        if (
          this.isActiveConversation() ||
          this.getTimeInSec(lap) < this.state.timer
        ) {
          clearInterval(this.timer);
          this.setState({ isVisible: false });
        }
      }
    }

    let msg = s360ConfigService.config?.popupMessage.find(
      ({ time }) => this.getTimeInSec(time) === interval
    );

    //for popup effect only..
    let check = s360ConfigService.config?.popupMessage.find(
      ({ time }) => this.getTimeInSec(time) === interval + 1
    );
    if (check != undefined) {
      this.setState({ isVisible: false });
    }

    //To display message
    if (msg != undefined) {
      let text = msg.text;
      //   if(window.innerWidth < 500 && s360ConfigService.timerMessages.length>0)
      //  { window.parent.postMessage(
      //     {
      //       iframeMinimizedandPopup:'true'
      //     },
      //     "*"
      //   )}
      this.setState({ text: text, isVisible: true });
    }
  };

  actions = {
    refreshForFullScreen: () => {
      this.setState({ refreshForFullScreen: true });
    },
    startChat: (formDetails) => {
      this.login(formDetails);
    },
    startConversation: (details, completionHandler) => {
      this.startConversation(details, completionHandler);
    },
    showLandingScreen: () => {
      this.moveToPage(Simplify360Chat.pageName.landingPage);
    },
    onStartUpClick: () => {
      this.onStartUpClick();
    },
    markActiveConversationAsClosed: () => {
      this.markActiveConversationAsClosed();
    },
    onHideChatWindow: () => {
      this.setState({ isAppOpen: false });
    },
    showPopUpMessage: (message) => {
      this.showPopUpMessage(message);
    },
    submitForm: (contactFormDetails) => {
      this.submitForm(contactFormDetails);
    },
    showPopUpMessageAction: (message) => {
      this.showPopUpMessageAction(message);
    },
    closePopup: () => {
      this.closePopup();
    },
  };

  moveToConversationPage = () => {
    this.forceAutoLogin();
    // this.moveToPage(Simplify360Chat.pageName.conversationPage)
  };
  forceAutoLogin = () => {
    let configFormDetails = { ...s360ConfigService.s360UserConfig };
    this.login(configFormDetails);
  };
  checkAndAutoLogin = () => {
    // console.log("qaw");
    s360ConfigService.loadClientConfigFromToken();
    if (
      !HWUser.isLoggedIn() &&
      s360ConfigService.config.configDetails?.showForm === false &&
      this.state.isAppOpen
    ) {
      // Auto Login
      let configFormDetails = { ...s360ConfigService.s360UserConfig };

      this.login(configFormDetails);

      // alert("AUTO LOGIN");
    }
  };

  onStartUpClick = () => {
    let updatedState = !this.state.isAppOpen;
    // console.log("isAppOpen", this.state.isAppOpen);
    if (updatedState) {
      if (localStorage.getItem("openInFullScreen")) {
        window.parent.postMessage(
          {
            fullScreen: "true",
          },
          "*" //or "www.parentpage.com"
        );
      }
      localStorage.getItem("openInFullScreen") === undefined ||
        (localStorage.getItem("openInFullScreen") === null && sendOnAppOpen());
    } else {
      sendOnAppClose();
    }
    this.setState({ isAppOpen: updatedState }, () => {
      if (!this.isLoggedIn) {
        this.checkAndAutoLogin();
      }
    });
    localStorage.removeItem("finalvalue");
  };

  login = (formDetails) => {
    if (this.props.user !== null) {
      // formDetails.user = JSON.parse(this.props.user)
    }
    return apiService
      .logInWithFormData(formDetails)
      .then((loginResult) => {
        HWLog.info("LOGIN Result: ", loginResult.data);
        if (!loginResult.data || loginResult.data.error) {
          this.setState({ errorMessage: loginResult.data.error || "" }, () => {
            this.showPopUpMessage(loginResult.data.error || "Something went worng. Please try again.")
          });
        } else {
          // successful login
          const oldUserData = HWUser.user() || {}
          const newUserData = { ...oldUserData, ...loginResult.data }

          // used to update user data in context and localstorage
          HWUser.updateUserDetails(newUserData)
          this.context.updateUserData(newUserData)

          // console.log(
          //   "COMETD-LOG:1.RECIEVED CLIENT CHANNEL AFTER LOGIN",
          //   loginResult.data,
          //   this.props.appRef
          // );
          if (s360ConfigService.config.hideChatHis) {
            this.setState(
              {
                showActivityIndicator: false,
                clientChannel: newUserData,
                autoLoggedIn: true,
              },
              () => {
                this.moveToPage(Simplify360Chat.pageName.landingPage); // cometD connection is handled on landing screen.
              }
            );
          } else {
            // this.props.configureCometd(newUserData.clientChannel,this.props.appRef)
            this.setState(
              { showActivityIndicator: false, clientChannel: newUserData },
              () => {
                this.moveToPage(Simplify360Chat.pageName.landingPage); // cometD connection is handled on landing screen.
              }
            );
          }
        }
      })
      .catch(this.onAPIError);
  };

  markActiveConversationAsClosed = () => {
    if (this.state.activeConversation) {
      let activeConversation = this.state.activeConversation;
      activeConversation.active = false;
      this.setState({ activeConversation: activeConversation });
      // console.log("SESS_BUG:6.MARKED ACTIVE CONVERSATION AS FALSE");
    }
  };

  showPopUpMessage = (message) => {
    if (!message) {
      return;
    }
    this.setState({
      showPopUpMessage: true,
      popUpMessage: message,
      showActivityIndicator: false,
      closeAction: this.closePopup,
    });
  };
  //handle error here from text boc and scroll and pass value here

  showPopUpMessageAction = (message) => {
    if (!message) {
      return;
    }
    this.setState({
      showPopUpMessage: true,
      popUpMessage: message,
      showActivityIndicator: false,
      closeAction: this.goToHome,
    });
  };

  // Moves to existing conversation.
  startConversation = (conversationDetials, completionHandler) => {
    const { saveUserMetaData } = CometdActions(this.context.cometdInstance);
    // console.log(
    //   "COMETD-LOG:PROCEEDING WITH FOLLOWING SESSION TO CONVERSATIONPAGE",
    //   conversationDetials
    // );
    this.setState(
      { activeConversation: conversationDetials, isActive: true },
      () => {
        clearInterval(this.timer);
        // console.log("COMETD-LOG:SENDING USER META DATA");
        saveUserMetaData(
          s360ConfigService.userData,
          conversationDetials.sessionId
        );
        // xmppService
        //   .sendUserMetaData(
        //     s360ConfigService.userData,
        //     conversationDetials.sessionId
        //   )
        //   .catch((error) => {
        //     console.log("couldn't send user meta data");
        //   });
        this.moveToPage(
          Simplify360Chat.pageName.conversationPage,
          completionHandler
        );
      }
    );
    // console.log("start");
  };

  moveToPage = (pageName, onStateUpdate) => {
    this.setState({ visiblePage: pageName }, () => {
      onStateUpdate && onStateUpdate();
    });
  };

  configureAndConnectToXMPP = (xmpppConfig) => {
    xmppService.configure(xmpppConfig).catch(this.onAPIError);
  };

  onAPIError = (error) => {
    let messageToShow =
      error && error.message === "Network Error"
        ? "Please check your internet connectivity."
        : "Could not connect to server, please try again.";
    // HWLog.error(error, messageToShow);
    // console.log("error:", error);
    // console.log("ms:", error.Message);
    this.showPopUpMessage(messageToShow);
    // alert("Could not connect to the server. Please try again.");
  };

  containerStyle = () => {
    var x = window.matchMedia("(max-width: 400px)");

    return {
      display: !this.state.isAppOpen ? "none" : "flex",

      background:
        s360ConfigService?.config?.designDetails?.headerBackgroundImage !==
          undefined &&
        s360ConfigService?.config?.designDetails?.headerBackgroundImage !== ""
          ? "url(" +
            s360ConfigService?.config?.designDetails?.headerBackgroundImage +
            ")"
          : s360ConfigService?.config?.designDetails?.headerColor,
      borderColor: s360ConfigService?.config?.designDetails?.headerColor,
      borderStyle: "none",
      borderWidth: "0.5px",

      borderRadius: x.matches
        ? "0px"
        : localStorage.getItem("openInFullScreen")
        ? "0px"
        : "10px",
      // height:"640px",
      // width:"360px"
    };
  };

  submitForm = (contactFormDetails, func) => {
    return apiService
      .createTicketWithFormData(contactFormDetails)
      .then((result) => {
        HWLog.info("Contact form result: ", result.data);
        if (!result.data || result.data.error) {
          this.setState({ errorMessage: result.data.error || "" }, () => {
            this.showPopUpMessageAction(
              result.data.error || "Something went worng. Please try again."
            );
          });
        } else {
          this.showPopUpMessageAction("Form submitted successfully");
        }
      })
      .catch(this.onAPIError);
  };

  goToHome = () => {
    this.setState({
      showPopUpMessage: false,
      popUpMessage: null,
      goback: true,
    });
  };

  closePopup = () => {
    this.setState({ showPopUpMessage: false, popUpMessage: null });
  };

  parseSurveyTriggerResponse = (msg) => {
    this.setState({
      showFeedbackIframe: true,
      iframeSRC: msg?.message?.text,
      sessionIdForClose: msg?.sessionId,
    });

    // if(s360ConfigService?.config?.hideIcon){
    //   localStorage.removeItem("isLoggedIn")
    // }
  };

  handleCloseIcon = () => {
    localStorage.setItem("SURVEY_TRIGGERED", "true");
    this.setState({ showFeedbackIframe: false, isIframeClose: true });
    if (s360ConfigService?.config?.secondaryConfig) {
      window.parent.postMessage(
        {
          switchBotToDefault: "true",
        },
        "*"
      );
    }
  };
  resetIframe = () => {
    this.setState({ isIframeClose: false });
  };
  showLogsModal = () => {
    return // TODO: enable for prod
    const localStorageLogs = getUILogs()
    !this.state.showLogs && 
    this.setState({
      showLogs: true,
      logs: localStorageLogs?.data ?? []
    })
  }
  hideLogsModal = () => {
    this.setState({
      showLogs: false
    })
  }
  render() {
    const { showFeedbackIframe, isIframeClose, sessionIdForClose } = this.state;
    let isLoggedIn = HWUser.isLoggedIn();
    const isFullScreen = localStorage.getItem("openInFullScreen");
    return (
      <>
        {!s360ConfigService.config.hideIcon && (
          <StartUp actions={this.actions} />
        )}
        {this.state.isAppOpen && (
          <div
            className={
              isFullScreen
                ? "s360-main-float-container-fs"
                : "s360-main-float-container"
            }
            id="container"
            style={this.containerStyle()}
            ref={this.dialogRef}
            role="dialog"
            aria-modal="true"
            aria-labelledby="livechat-title"
          >
            {this.state.visiblePage ===
              Simplify360Chat.pageName.offlinePage && (
              <InitialForm
                key={"inital-form-" + false}
                config={s360ConfigService.config}
                actions={this.actions}
                {...this.state}
              />
            )}
            {this.state.visiblePage ===
              Simplify360Chat.pageName.initialForm && (
              <InitialForm
                moveToConversationPage={() => {
                  this.moveToConversationPage();
                }}
                key={"inital-form-" + isLoggedIn}
                config={s360ConfigService.config}
                actions={this.actions}
                {...this.state}
                errorMessage={this.state.popUpMessage}
              />
            )}
            {this.state.visiblePage ===
              Simplify360Chat.pageName.landingPage && (
              <LandingPage
                uniboxSingleRefreshChange={() => {
                  this.setState({ uniboxSingleRefresh: true });
                }}
                key={"landing-page-" + isLoggedIn}
                config={s360ConfigService.config}
                actions={this.actions}
                {...this.state}
                isActive={this.isActiveCallback}
                clientChannel={this.state.clientChannel}
                showLogsModal={this.showLogsModal}
                {...this.props}
              />
            )}
            {this.state.visiblePage ===
              Simplify360Chat.pageName.conversationPage && (
              <ConversationPage
                uniboxSingleRefresh={this.state.uniboxSingleRefresh}
                resetIframe={() => this.resetIframe()}
                chatStatus={this.state.isAppOpen}
                key={"conversation-page-" + isLoggedIn}
                config={s360ConfigService.config}
                conversation={this.state.activeConversation}
                actions={this.actions}
                showLogsModal={this.showLogsModal}
                {...this.state}
                parseSurveyTriggerResponse={(e) =>
                  this.parseSurveyTriggerResponse(e)
                }
                headingRef={this.headingRef}
                isIframeClose={isIframeClose}
                sessionIdForClose={sessionIdForClose}
              />
            )}
            {this.state.showActivityIndicator && (
              <ActivityIndicator
                config={s360ConfigService.config}
                actions={this.actions}
                {...this.state}
              />
            )}
            {this.state.showPopUpMessage && (
              <PopUpMessage
                popUpMessage={this.state.popUpMessage}
                onClose={this.state.closeAction}
                addTodoItem={this.props.addTodoItem}
              />
            )}

            <Modal
              open={this.state.showLogs}
              onClose={this.hideLogsModal}
              aria-labelledby="logs-modal-title"
            >
              <Box sx={{ margin: "3rem", backgroundColor: 'white', p: 2 }}>
                <Grid container justifyContent='space-between'>
                  <Typography id="logs-modal-title" variant="h6" component="h2">
                    UI Logs
                  </Typography>
                  <Button onClick={this.hideLogsModal}>Close</Button>
                </Grid>
                {this.state.logs?.length > 0 
                  ? this.state.logs.map((log, index) => 
                    <Typography sx={{ mt: 2 }} key={`ui-logs-items-${index}`}>{index+1}. {log.timestamp || ''}: {log.message || ''}</Typography>
                  ) : <Typography sx={{ mt: 2 }}>No logs available.</Typography>
                }
              </Box>
            </Modal>
          </div>
        )}

        {showFeedbackIframe && (
          <IframeContainer
            src={this.state.iframeSRC}
            handleCloseIcon={this.handleCloseIcon}
            hideCloseButton={s360ConfigService?.config?.configDetails?.hideCloseBtnInFeedbackForm}
          />
        )}
        {!HWUser.isLoggedIn() &&
          this.state.isVisible &&
          !this.state.isAppOpen &&
          s360ConfigService.config.enableTimerMessages && (
            <div
              id="s360-popup-float-message-container-id"
              className="s360-popup-float-message-container s360-hidden"
            >
              <div className="s360-popup-float-img">
                <img
                  src={closeImg}
                  height="8px"
                  alt="Close"
                  width="8px"
                  float="right"
                  role="button"
                  tabIndex={0}
                  aria-label="Close"
                  style={{
                    marginBottom: "4px",
                    marginLeft: "128px",
                    cursor: "pointer",
                  }}
                  id="s360-popup-float-img-id"
                  onClick={this.handleClose}
                  onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); this.handleClose(e); } }}
                ></img>
              </div>
              <span
                id="s360-popup-float-message-id"
                className="s360-popup-float-message"
              >
                {this.state.text}
              </span>
            </div>
          )}
      </>
    );
  }
}

export default Simplify360Chat;
